/**
 * Birthday utilities for GLOSS
 */
export function daysUntilBirthday(dob) {
  if (!dob) return null;
  const parts = dob.split("-");
  if (parts.length !== 3) return null;
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);
  if (!month || !day) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let next = new Date(today.getFullYear(), month - 1, day);
  if (next < today) {
    next = new Date(today.getFullYear() + 1, month - 1, day);
  }
  return Math.round((next - today) / (1000 * 60 * 60 * 24));
}

export function formatBirthdayLabel(days) {
  if (days === null || days === undefined) return null;
  if (days === 0) return "Today!";
  if (days === 1) return "Tomorrow";
  if (days <= 7) return `${days} days`;
  return `${days} days`;
}
